import React from 'react';
import FormBuilder from './FormBuilder';

const EditForm = () => {
  return <FormBuilder mode="edit" />;
};

export default EditForm;